"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var JsonRpcError_1 = __importDefault(require("./response/JsonRpcError"));
var RpcRequest_1 = __importDefault(require("./request/RpcRequest"));
var RpcNotification_1 = __importDefault(require("./request/RpcNotification"));
var RpcSuccess_1 = __importDefault(require("./response/RpcSuccess"));
var RpcError_1 = __importDefault(require("./response/RpcError"));
/**
 * Parse message as json rpc error
 */
function parse(message) {
    if (!message) {
        return JsonRpcError_1.default.parseError({
            id: null,
            data: 'Cannot parse undefined',
        });
    }
    if (typeof message === 'string') {
        try {
            message = JSON.parse(message);
        }
        catch (error) {
            return JsonRpcError_1.default.parseError({
                id: null,
                data: error,
            });
        }
    }
    return parseJsonRpc(message);
}
exports.default = parse;
function parseJsonRpc(jsonRpc) {
    if (!Array.isArray(jsonRpc)) {
        return parseObject(jsonRpc);
    }
    return jsonRpc.map(function (object) { return parseObject(object); });
}
function parseObject(object) {
    if (object instanceof Error) {
        return JsonRpcError_1.default.parseError({
            id: '',
            data: {
                description: 'Failed to parse Error object.',
                cause: {
                    name: object.name,
                    message: object.message,
                    stack: object.stack,
                    originalError: object,
                },
            },
        });
    }
    if (!('method' in object) &&
        !('result' in object) &&
        !('error' in object)) {
        return JsonRpcError_1.default.parseError({
            id: object.id,
            data: "No method, result or error attributes found. Not Json Rpc 2 object with keys: ".concat(Object.keys(object).join(', ')),
        });
    }
    if ('method' in object && ('result' in object || 'error' in object)) {
        return JsonRpcError_1.default.parseError({
            id: object.id,
            data: {
                error: "Method, and result or error attributes found. Not Json Rpc 2 object with keys: ".concat(Object.keys(object).join(', ')),
                object: object,
            },
        });
    }
    if ('method' in object) {
        return parseRequest(object);
    }
    return parseResponse(object);
}
function parseRequest(object) {
    if ('id' in object) {
        return new RpcRequest_1.default(object);
    }
    return new RpcNotification_1.default(object);
}
/**
 * @param {Object} object
 * @return {JsonRpcError|RpcError|RpcSuccess}
 */
function parseResponse(object) {
    if ('result' in object && 'error' in object) {
        return JsonRpcError_1.default.parseError({
            id: object.id,
            data: {
                error: "Result and error keys found. Not Json Rpc 2 object with keys: ".concat(Object.keys(object).join(', ')),
                object: object,
            },
        });
    }
    if ('result' in object) {
        return new RpcSuccess_1.default(object);
    }
    if ((object.error.code >= -32000 && object.error.code <= -32099) ||
        [-32700, -32600, -32601, -32602, -32603].includes(object.error.code)) {
        return new JsonRpcError_1.default(object);
    }
    return new RpcError_1.default(object);
}
//# sourceMappingURL=parse.js.map